import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    toastText: "",
    userData: JSON.parse(localStorage.getItem("UserData")) || {},
    userinfo: JSON.parse(localStorage.getItem("UserInfo")) || {},
    loadingVisible: false,
    token: JSON.parse(localStorage.getItem("x_token")) || "",
    headers: {},
    state: "",
    code: "",
    appid: process.env.APP_ID,
    redirect_url: process.env.REDIRECT_URL
  },
  //actions——用于响应组件中的动作
  actions: {
    toast(state, text) {
      state.toastText = text;
      setTimeout(() => {
        state.toastText = "";
      }, 2000);
    },
    getcode(state, code) {
      state.state = state;
      state.code = code;
    }
  },
  // mutations——用于操作数据
  mutations: {
    getUserData(state, value) {
      value.avatar = "https://www.helloimg.com/images/2022/06/30/ZM480c.jpg";
      state.userData = value;
      localStorage.setItem("UserData", JSON.stringify(value));
    },
    getUserinfo(state, value) {
      state.userinfo = value;
      localStorage.setItem("UserInfo", JSON.stringify(value));
    },
    gettoken(state, token) {
      state.token = token;
      localStorage.setItem("x_token", JSON.stringify(token));
    },
    getheaders(state, value) {
      state.headers = value;
    },
    increment(state) {
      state.count++;
    },
    loading(state, loadingVisible) {
      state.loadingVisible = loadingVisible;
    },
    requireLogin(state) {
      const host =
        process.env.NODE_ENV === "development"
          ? "wxtest.zhichou.com"
          : "wx.zhichou.com";
      location.assign(
        "http://" +
          host +
          "/#/me/login?rurl=" +
          encodeURIComponent(location.href)
      );
    },
    getLicenses(state, licenses) {
      state.userData.licenses = licenses;
    }
  },
  getters: {
    userinfo: state => state.userinfo,
    token: state => state.token
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js